// extracted by mini-css-extract-plugin
export default {"timesheetEntryCard":"add-new-entry-card_timesheetEntryCard__jUIer","button":"add-new-entry-card_button__0Skzm"};